const splitter = '|';
const token = 'search_string';
const maxTerms = 5;

function writeSearchHistory (newterm) {
  if (typeof newterm !== 'undefined' && newterm.length > 0) {
    const terms = readSearchHistory();

    // remove term if exist
    const index = terms.indexOf(newterm.toLowerCase());
    if (index > -1) {
      terms.splice(index, 1);
    }

    // insert term first
    terms.unshift(newterm);
    // set the defined number of terms to history
    const data = terms.slice(0, maxTerms).join('|');
    window.$cookies.set(token, data.toLowerCase(), -1);
  }
}

function readSearchHistory () {
  if (!window.$cookies.isKey(token)) {
    return [];
  }
  const data = window.$cookies.get(token);
  if (data === null || data === '') {
    return [];
  }
  return data.split(splitter);
}

function removeSearchHistory () {
  window.$cookies.remove(token);
}

function getSearchPageLink (term, addParam = true) {
  const path = 'search';
  const key = 'searchtext';
  if (addParam) {
    return `/${document.documentElement.lang}/${path}/?${key}=${term}`;
  }
  return `/${document.documentElement.lang}/${path}/`;
}

export default {
  writeSearchHistory,
  readSearchHistory,
  removeSearchHistory,
  getSearchPageLink
};
